import {Dispatch, FC, SetStateAction, useEffect, useState} from 'react'
import {useQueryResponse} from '../core/QueryResponseProvider'
import {InvoiceTypeSelect} from '../InvoiceTypeSelect'
import {InvoiceExcelModalForm} from './InvoiceExcelModalForm'

type Props = {
  title: {
    title: string
    setTitle: Dispatch<SetStateAction<string>>
  }
  invoiceType: {
    invoiceType: number
    setInvoiceType: Dispatch<SetStateAction<number>>
  }
  invoiceTemplate: {
    invoiceTemplate: number
    setInvoiceTemplate: Dispatch<SetStateAction<number>>
  }
  action: {
    excelModal: boolean
    setExcelModal: React.Dispatch<React.SetStateAction<boolean>>
  }
}

const InvoiceExcelModalBody: FC<Props> = ({title, action, invoiceType, invoiceTemplate}) => {
  useEffect(() => {}, [title.title])

  return (
    <>
      <div className='fv-row'>
        {invoiceType.invoiceType == 0 && (
          <InvoiceTypeSelect
            title={title}
            invoiceType={invoiceType}
            invoiceTemplate={invoiceTemplate}
          />
        )}
        {invoiceType.invoiceType != 0 && (
          <InvoiceExcelModalForm
            action={action}
            invoiceType={invoiceType.invoiceType}
            invoiceTemplate={invoiceTemplate.invoiceTemplate}
          />
        )}
      </div>
    </>
  )
}

export {InvoiceExcelModalBody}
